export default {"src":"/_next/static/media/Inlinked.205e3e3a.svg","height":28,"width":29};